export enum BookingKindEnum {
    IN_STAY = 'instay',
    PRE_ARRIVAL = 'prearrival',
}
